import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore, isAdmin } from '@/store/authStore'
import { useUIStore } from '@/store/uiStore'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuthStore()
  const location = useLocation()
  const showToast = useUIStore((s) => s.showToast)

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      showToast('Please sign in to access this page', 'error')
    }
  }, [isLoading, isAuthenticated, showToast])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!isAuthenticated) {
    // Store intended destination for redirect after login
    return <Navigate to="/" state={{ from: location, requiresAuth: true }} replace />
  }

  return <Outlet />
}

export function AdminRoute() {
  const { user, profile, isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!isAuthenticated || !isAdmin(user?.email, profile)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
